export const adaptAreaPayload = (
	values: AreaFormValues
): Record<string, unknown> => {
	return {
		name: values.name,
		region: values.region !== "" ? Number(values.region) : null,
		area_manager: values.areaManager !== "" ? Number(values.areaManager) : null
	};
};
